import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a82273c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "channel_main_title title_22B" }, " 1:1 협의 ", -1))
const _hoisted_3 = { class: "bg_wrap" }
const _hoisted_4 = { class: "bg_image" }
const _hoisted_5 = { class: "channel-container" }
const _hoisted_6 = { class: "lock_box" }
const _hoisted_7 = { class: "login-info" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "lock",
    src: "/assets/image/lock.png",
    srcset: "/assets/image/lock@2x.png 2x,/assets/image/lock@3x.png 3x"
  })
], -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 로그인 하시면 1:1 협의 현황을 볼 수 있어요. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: "" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("div", null, [
                        _createElementVNode("div", {
                          class: "login_btn",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$global.openLoginModal()))
                        }, " 로그인 ")
                      ]),
                      _hoisted_9
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}